import api from '@/api/index';

const namespaced = true;

const state = {
  agencies: [],
  agenciesFiles: {}
};

const getters = {
  agencies: (state) => state.agencies,
  agenciesFiles: (state) => state.agenciesFiles
};

const mutations = {
  SET_AGENCIES: (state, payload) => {
    state.agencies = payload;
  },
  SET_AGENCIES_FILES: (state, payload) => {
    state.agenciesFiles = payload;
  }
};

const actions = {
  async fetchAgencies({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const params = {
        search: filterConfig.search,
        ...payload
      }
      const { data } = await api.getAgencyManagements(params);

      if (data.error) {
        commit('SET_AGENCIES', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_AGENCIES', data)
      commit('Table/SET_TOTAL_DATA', data.total ?? 0, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
      return data
    } catch (error) {
      throw error.data;
    }
  },

  async getAgencyManagementByName(_, payload) {
    try {
      const params = {
        name: payload
      }
      const { data } = await api.getAgencyManagementByName(params);

      return data
    } catch (error) {
      throw error.data;
    }
  },

  async postAgency(_, payload) {
    try {
      await api.postAgencyManagement(payload);
    } catch (error) {
      throw error.data;
    }
  },

  async putAgency(_, payload) {
    try {
      await api.putAgencyManagement(payload.id, payload.form);
    } catch (error) {
      throw error.data;
    }
  },

  async deleteAgency(_, payload) {
    try {
      await api.deleteAgencyManagement(payload);
    } catch (error) {
      throw error.data;
    }
  },
  async downloadAgencies({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const response = await api.getAgencyManagementsExcelDownload({
        search: filterConfig.search,
        ...payload})
      if (response) {
        commit('SET_AGENCIES_FILES', response)
      }
    } catch (err) {
      throw err
    }
  },
  resetAgenciesFiles({ commit }) {
    commit('SET_AGENCIES_FILES', {})
  }
};

export default { namespaced, state, getters, mutations, actions };
